<template>
    <div class="company-step">
      <div class="company-step-title">
        <h3>Для какой компании создаём вакансию?</h3>

        <div class="premium-hint">
          У вас активна подписка <strong>Fullstack HR</strong> — вы можете выбрать,
          для какой компании создаёте вакансию.
        </div>
      </div>
  
      <div class="company-list">
        <div
          v-for="c in companies"
          :key="c.company_id"
          class="company-item"
          :class="{ selected: selectedCompany === c.company_id }"
          @click="selectCompany(c)"
        >
          <img :src="c.logo_url" class="logo" alt="" />
          <div class="info">
            <strong>{{ c.name }}</strong>
            <p>{{ c.specifics }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  import UserService from "../../api/UserService";
  
  const emit = defineEmits(["valid", "notValid"]);
  const companies = ref([]);
  const selectedCompany = ref(null);
  
  onMounted(async () => {
    const user = await UserService.getProfile();
    companies.value = user.companies || [];
  
    emit("notValid");
  });
  
  function selectCompany(c) {
    selectedCompany.value = c.company_id;
    localStorage.setItem("vacancy_company_id", c.company_id);
  
    emit("valid");
  }
  </script>
  
  <style scoped>

  .company-step-title {
    margin-left: 40px;
  }

  .company-list {
    width: 600px;
    margin-left: 40px;
    width: 600px;
  }

  .company-step {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 600px;
  }

  .company-item {
    width: 400px;
    height: 60px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    border-radius: 12px;
    background: #f7f7f7;
    cursor: pointer;
    transition: .2s;
    margin-bottom: 10px;
  }
  
  .company-item.selected {
    border: 2px solid #3b82f6;
    background: #eef4ff;
  }
  
  .logo {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
  }

  .premium-hint {
  margin-top: 8px;
  padding: 10px 14px;
  max-width: 380px;

  background: #ffffff;
  color: #333;
  font-size: 13px;
  border-radius: 12px;
  border: 1px solid #d0d0d0;
  font-family: "Eastman-Medium";

  position: relative;
  animation: fadeIn 0.25s ease-out;
}

/* Хвостик как у speech bubble */
.premium-hint::after {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;
  width: 12px;
  height: 12px;

  background: white;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;

  transform: rotate(45deg);
}

/* Dark theme */
html[data-theme="dark"] .premium-hint {
  background: #2c2c2e;
  border-color: #555;
  color: #eee;
}

html[data-theme="dark"] .premium-hint::after {
  background: #2c2c2e;
  border-color: #555;
}

/* Анимация */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
  </style>